import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Icon, DomEvent, Map, LeafletEvent, LayerGroup, MapOptions, tileLayer, LatLng, latLng, Marker , MarkerClusterGroup, MarkerClusterGroupOptions, divIcon, ZoomAnimEvent, FullscreenOptions, Control, DomUtil, control, marker } from 'leaflet';
import { mapURL } from 'src/environments/environment.api';

@Component({
  standalone: false,
  selector: 'app-report-tag-event-map-dialog',
  templateUrl: './report-tag-event-map-dialog.component.html',
  styleUrls: ['./report-tag-event-map-dialog.component.scss']
})
export class ReportTagEventMapDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  @Output() map$: EventEmitter<Map>= new EventEmitter;
  @Output() zoom$: EventEmitter<number>=new EventEmitter;
  zoom!:number;
  public map!: Map;

  getCoords():LatLng {
    if(this.data.coords !== null){
      var coord = this.data.coords.split(" ");
      const mark1= coord[1].split("(");
      const mark2= coord[2].split(")");
      const x=Number(mark2[0]) as number
      const y= Number(mark1[1]) as number
      var coords:LatLng
      if (x > y){
        coords = new LatLng(x as number, y as number)
      } else {
        coords = new LatLng(y as number, x as number)
      }
      return coords
      }
    return new LatLng(45.800084381319905, 13.38134765625)
  }
  mapUrl = mapURL.mapUrl !== '${mapURL}' ? mapURL.mapUrl : mapURL.defaultMapUrl;
  @Input() options: MapOptions= {
      layers:[tileLayer(`${this.mapUrl}/styles/m2openmaptiles/{z}/{x}/{y}.png`, {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    })],
    zoom:17,
    center:latLng(this.getCoords()),
  };

  setIcon(){
    const zoom = this.map.getZoom();
    return Icon.extend({
      options:
        {
          iconSize: [zoom+20, zoom+20], // size of the icon
          iconAnchor: [zoom / 2, zoom], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -zoom],  
          iconUrl: '../../../../assets/images/bin.png'
        }
    })
  }


  onMapReady(map: Map) {
      this.map = map;
      this.map$.emit(map);
      this.zoom = map.getZoom();
      this.zoom$.emit(this.zoom);
     
      const marker_icon=this.setIcon();
      marker(this.getCoords(), {icon:new marker_icon}).bindPopup(this.data.pop_up_data, {closeButton: false}).addTo(map);
    }

  onMapZoomEnd(e: LeafletEvent) {
    this.zoom = e.target.getZoom();
    this.zoom$.emit(this.zoom);
  }
}

export type DialogMapParams = {
  data: any;
};

